import React from 'react';
import _join from 'lodash/join';
import _size from 'lodash/size';
import Tooltip from '@tekion/tekion-components/src/atoms/tooltip';

export const tooltipForTags = ommitedValues => (
  <Tooltip title={_join(ommitedValues, ', ')}>{`+${_size(ommitedValues)}`}</Tooltip>
);
